import {
  GET_SMALLER_COMPANIES_BY_SECTOR,
  GET_SMALLER_COMPANIES_BY_SECTOR_ERROR,
  GET_SMALLER_COMPANIES_BY_SECTOR_SUCCESS
} from './SmallerCompaniesBySector.actions'

const initialState = {
  data: [],
  dataAccumulated: [],
  series: [],
  csv: [],
  loading: false,
  error: null
}
/**
 * The smaller Companies By Sector's reducer.
 */
const smallerCompaniesBySectorReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_SMALLER_COMPANIES_BY_SECTOR:
      return { ...state, loading: true }
    case GET_SMALLER_COMPANIES_BY_SECTOR_SUCCESS:
      return {
        ...state,
        csv: payload.csv,
        data: payload.data,
        dataAccumulated: payload.dataAccumulated,
        series: payload.series,
        loading: false
      }
    case GET_SMALLER_COMPANIES_BY_SECTOR_ERROR:
      return { ...state, error: payload.error, csv: [], data: [], dataAccumulated: [], series: [], loading: false }
    default:
      return state
  }
}

export default smallerCompaniesBySectorReducer
